var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133 133",
    style: {
      enableBackground: "new 0 0 133 133"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF0F3;}\n\t.st1{fill:#E5F2FF;}\n\t.st2{fill:none;}\n\t.st3{fill:none;stroke:#5DA6FF;}\n\t.st4{fill:none;stroke:#A8D5FF;stroke-width:3;}\n\t.st5{fill:none;stroke:#001C4A;stroke-width:2;}\n\t.st6{fill:#001C4A;}\n\t.st7{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UP",
    transform: "translate(963 -542.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -23, -22)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11-2",
    className: "st0",
    cx: -875,
    cy: 630.5,
    r: 43
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -23, -22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    className: "st1",
    d: "M-875,587.5c23.7,0,43,19.3,43,43s-19.3,43-43,43s-43-19.3-43-43S-898.7,587.5-875,587.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    transform: "translate(17 17)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -913.5,
    cy: 592,
    r: 49.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -913.5,
    cy: 592,
    r: 49
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_35",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -903.5,
    cy: 602,
    r: 59.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: -903.5,
    cy: 602,
    r: 58
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_36"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -896.5,
    cy: 609,
    r: 66.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -896.5,
    cy: 609,
    r: 65.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "play_00000098189448893269371620000002015919282189652405_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40_00000095300614585611560660000006743191558943124406_",
    className: "st6",
    d: "M49.5,66.5c0-9.4,7.6-17,17-17 s17,7.6,17,17s-7.6,17-17,17S49.5,75.9,49.5,66.5L49.5,66.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67_00000166645347053666777280000015812445575685028241_",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45_00000150805142445143460140000010060222908852038036_",
    className: "st7",
    d: "M63.5,60h3c0.6,0,1,0.4,1,1v11 c0,0.6-0.4,1-1,1h-3c-0.6,0-1-0.4-1-1V61C62.5,60.4,62.9,60,63.5,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46_00000010294468149722773580000002129281360779921793_",
    className: "st7",
    d: "M70.5,60h3c0.6,0,1,0.4,1,1v11 c0,0.6-0.4,1-1,1h-3c-0.6,0-1-0.4-1-1V61C69.5,60.4,69.9,60,70.5,60z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseMob);
export default __webpack_public_path__ + "static/media/pause-mob.729661230ee802059eeb6581be3dc6df.svg";
export { ForwardRef as ReactComponent };